module.exports = __webpack_public_path__ + "static/media/print-gray.41c3823b.svg";